import axios from "axios";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import React, { useEffect, useRef, useMemo, useState } from "react";
import DataTableComponentFrontPagination from "../../common/DataTableComponentFrontPagination";
import HtmlParser from "react-html-parser";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import SkeletonTicketList from "../../../loaders/SkeletonTicketList";
import {
    GetTemplateListCancelToken,
    GetTemplateListFilters,
    DeleteTemplate
} from "../../../services/ProjectCenterServices";
import { RenderModuleStatus, RenderModuleType } from "../../../utils/CommonGroupingItem";
import { TABLE_ROWS_PER_PAGE } from "../../../utils/Constants";
import PermissionsGate from "../../../utils/permissionGate";
import Str from "../../common/Str";
import Tablefilter from "../../common/Tablefilter";
import { TrimText } from "../../common/TrimText";

const PCTemplateList = () => {
    const history = useHistory();

    const [templateList, setTemplateList] = useState();
    const [loading, setLoading] = useState(false);

    const [search, setSearch] = useState("");
    const [department, setDepartment] = useState({ arr: [], checkObj: {} });
    const [filterData, setFilterData] = useState({ arr: [] });
    const debounceRef = useRef();
    usePermissionGuardRedirect(['projectcentertemplatesview']);
    const getListOfTemplates = async (cancelToken) => {
        setLoading(true);

        try {
            const listOfTemplatesResponse = await GetTemplateListCancelToken(
                {},
                cancelToken
            );
            setTemplateList(listOfTemplatesResponse?.data?.data || []);
        } catch (error) {
            if (!axios.isCancel(error)) {
                console.error(error);
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        const source = axios.CancelToken.source();

        getListOfTemplates(source.token);

        return () => source.cancel("Component unmounted");
    }, []);
    const handleDeleteTemplate = async (id) => {
        try {
            // confirmation swal
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
            }).then((swalResult) => {
                if (swalResult.isConfirmed) {
                    const deleteReponse = DeleteTemplate(id).then((deleteResult) => {
                        if (deleteResult.status === 200) {
                            setLoading(true);
                            Swal.fire("Deleted!", "Template has been deleted.", "success");
                            getListOfTemplates();
                            setLoading(false);
                        }
                    });
                }else{
                    setLoading(false);
                }
            });
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    }
    useEffect(() => {
        const dropdownSource = axios.CancelToken.source();

        const fetchData = async () => {
            try {
                const templateFiltersResponse = await GetTemplateListFilters(dropdownSource.token);
                setFilterData({ arr: templateFiltersResponse.data?.data })
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error(error);
                }
            }
        };

        fetchData();

        return () => {
            dropdownSource.cancel('Component unmounted');
        };
    }, []);
    const renderTemplateData = () => {
        let updatedData = []
        let allData = templateList && [...templateList] || []
        if (search.length) {
            let name = allData.filter(item => {
                let includes = item.name
                    ?.toString()
                    ?.toLowerCase()
                    ?.includes(search.toLowerCase())
                if (includes) {
                    return includes
                } else return null
            })

            let data = [...name]
            let unique = [...new Set(data)]

            updatedData = unique
        } else {
            updatedData = allData
        }

        if (department.arr.length) {
            let tempStatus = updatedData
            let tempResult = tempStatus.filter(item => {
                const startsWith = department.arr.find(function (departmentId, index) {
                    if (
                        item.department && Number(departmentId) == Number(item.department)
                            ? item.department
                            : ''
                    )
                        return item
                })
                if (startsWith) {
                    return startsWith
                } else return null
            })
            updatedData = tempResult
        }
        if (
            search.length ||
            department.arr.length
        ) {
            const uniqueData = updatedData.filter(
                (value, index, self) =>
                    index ==
                    self.findIndex(
                        t =>
                            t.id == value.id
                    ),
            )
            return uniqueData
        } else {
            const uniqueData = allData.filter(
                (value, index, self) =>
                    index ==
                    self.findIndex(
                        t =>
                            t.id == value.id
                    ),
            )
            return uniqueData
        }
    }
    const columns = useMemo(() => [
        {
            name: "Name",
            selector: "name",
            sortable: true,
            cell: (row) => (
                <Link
                    to={`/project-center/templates/open/${row.id}`}
                    className="as-text-blue curser feature-name"
                    title={row.name}
                >
                    {row?.name.trim() ? <span className="textLimit100">{row?.name}</span> : "-"}
                </Link>
            ),
        },
        {
            name: "Department",
            selector: "department",
            sortable: true,
            cell: (row) => (
                <div className="ticket-id">
                    {row.department ? (
                        <span title={row.department} className="overflow-ellipsis2">
                            {filterData.arr
                                .filter((item) => item.value == row.department)
                                .map((item) => item.label)}
                        </span>
                    ) : (
                        "-"
                    )}
                </div>
            ),
        },
        {
            name: "# Active Projects",
            selector: "project_count",
            sortable: true,
            cell: (row) => (
                <div className="ticket-id">
                    {row.project_count ? (
                        <span title={row.project_count} className="overflow-ellipsis2">
                            {row.project_count}
                        </span>
                    ) : (
                        "0"
                    )}
                </div>
            )
        },
        {
            name: "Actions",
            selector: "",
            cell: (row) => (
                <div className="assessment-08 btn-dropdown-grp">
                    <div className="as-buttons d-flex">
                            <Link
                                to={`/project-center/templates/open/${row.id}`}
                                className="btn btn-primary rounded-circle"
                                title="Open"
                            >
                                <i className="fal fa-folder-open"></i>
                            </Link>
                    <PermissionsGate scopes={['projectcentertemplatesdelete']} errorProps={{ disabled: true }}>
                            <button
                                className="btn btn-danger rounded-circle"
                                title="Delete"
                                onClick={() => handleDeleteTemplate(row.id)}
                            >
                                <i className="fal fa-trash-alt"></i>
                            </button>
                    </PermissionsGate>
                </div>
                </div>
            ),
        },
    ]);

    return (
        <div className="tab-pane fade active show"
            id="pills-tab11"
            role="tabpanel"
            aria-labelledby="pills-tab1"
        >
            {loading ? (
                <SkeletonTicketList />
            ) : (
                <DataTableComponentFrontPagination
                    data={renderTemplateData()}
                    columns={columns}
                    tableButton={[
                        <Link to={`/project-center/templates/open`}>
                            <PermissionsGate errorProps={{ disabled: true }} scopes={["projectcentertemplatesadd"]} >
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    title="Create new"
                                >
                                    <i className="fal fa-plus"></i>Create New
                                </button>
                            </PermissionsGate>
                        </Link>
                    ]}
                    loading={loading}
                    search={search}
                    setSearch={setSearch}
                    isExport={false}
                    hidePdf={true}
                    defaultSort={{
                        defaultSortColumn: 'start',
                        defaultSortAsc: false,
                    }}
                    filters={[
                        {
                            filterName: ' Department',
                            optionArr: filterData?.arr,
                            state: department,
                            setState: setDepartment,
                            uniqueId: 'department'
                        }
                    ]}
                />
            )}
        </div>
    );
};

export default PCTemplateList;
